import React from "react";
import { useContent } from "../lib/content";
import ArticleCard from "../components/ArticleCard";
import SEO from "../components/SEO";

export default function ArticlesPage() {
  const { articles } = useContent();
  const published = articles.filter((a) => a.published !== false);

  return (
    <>
      <SEO title="مقالات و یادداشت‌های علمی | تحسین" description="مجموعه مقالات درباره فواید عسل طبیعی افغانستان، زعفران هرات و میوه‌های خشک." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="articles-page">
        <header className="text-right mb-10">
          <span className="text-amber-700 font-semibold text-sm tracking-widest uppercase">بلاگ تحسین</span>
          <h1 className="text-4xl sm:text-5xl font-black text-stone-900 mt-2 mb-3">مقالات علمی و یادداشت‌ها</h1>
          <p className="text-stone-600 max-w-2xl">
            دانش خود را درباره محصولات طبیعی، خواص آن‌ها و نحوه تشخیص محصول اصل گسترش دهید.
          </p>
        </header>

        {published.length === 0 ? (
          <div className="text-center py-20 text-stone-500">هنوز مقاله‌ای منتشر نشده است.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
            {published.map((a, i) => (
              <ArticleCard key={a.id} article={a} index={i} />
            ))}
          </div>
        )}
      </section>
    </>
  );
}
